import { useContext } from "react";
import { LoadingGroupContext } from "./LoadingGroupContext";

/**
 * Indicates whether a parent `LoadingGroup` is currently loading.
 * @returns True if a parent `LoadingGroup` is loading, otherwise false.
 */
export function useLoading(): boolean {
  const { loading } = useContext(LoadingGroupContext);
  return loading;
}
